export default "__VITE_ASSET__BtwTTVef__"